(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["coverly-product-purchase-bar"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('coverly-sticky-cart')) {
    customElements.define('coverly-sticky-cart', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.events = new AbortController();
        const options = { signal: this.events.signal };
        this.button = this.querySelector('[data-sticky-cart-button]');
        this.mobile = matchMedia('(max-width: 749px)');
        this.schedule = () => {
          if (this.frame) return;
          this.frame = requestAnimationFrame(() => {
            this.frame = 0;
            this.bindSource();
            this.syncButton();
            this.updateVisibility();
          });
        };
        this.scheduleVisibility = () => {
          if (this.visibilityFrame || !this.mobile.matches) return;
          this.visibilityFrame = requestAnimationFrame(() => {
            this.visibilityFrame = 0;
            this.updateVisibility();
          });
        };
        this.button.addEventListener('click', () => {
          if (!this.source || this.source.disabled || this.source.getAttribute('aria-disabled') === 'true' || this.source.getAttribute('aria-busy') === 'true') return;
          this.source.click();
          this.syncButton();
          this.updateVisibility();
        }, options);
        this.mobile.addEventListener('change', this.schedule, options);
        window.addEventListener('resize', this.schedule, options);
        window.addEventListener('scroll', this.scheduleVisibility, { ...options, passive: true });
        document.addEventListener('focusin', this.schedule, options);
        document.addEventListener('focusout', this.schedule, options);
        document.addEventListener('shopify:section:load', this.schedule, options);
        document.addEventListener('shopify:section:unload', this.schedule, options);
        this.main = document.querySelector('main');
        this.mounts = new MutationObserver(this.schedule);
        if (this.main) this.mounts.observe(this.main, {
          childList: true, subtree: true, characterData: true, attributes: true,
          attributeFilter: ['data-ppo-native-atc', 'data-product-id']
        });
        this.bindSource();
        this.syncButton();
        this.updateVisibility();
      }

      bindSource() {
        const ppo = [...(this.main?.querySelectorAll('#coverly-configurator, #ppo-configurator') || [])]
          .find(element => element.dataset.productId === this.dataset.productId &&
            element.querySelector('[data-ppo-key], [data-ppo-atc]'));
        const scope = ppo?.closest('product-info, [id^="MainProduct-"], .shopify-section');
        const native = scope?.querySelector('button[id^="ProductSubmitButton-"]');
        const displayed = element => element?.getBoundingClientRect().height > 0 &&
          getComputedStyle(element).visibility !== 'hidden';
        const source = displayed(native) ? native :
          [...(ppo?.querySelectorAll('button[data-ppo-atc]') || [])].find(displayed);
        this.toggleAttribute('data-ppo-enabled', Boolean(source));
        if (source === this.source && ppo === this.configurator) return;
        this.changes?.disconnect();
        this.visibility?.disconnect();
        this.size?.disconnect();
        this.source = source;
        this.configurator = ppo;
        if (!source) return;
        this.changes = new MutationObserver(this.schedule);
        this.changes.observe(source, { attributes: true, childList: true, characterData: true, subtree: true });
        this.visibility = new IntersectionObserver(() => this.updateVisibility(), { threshold: [0, 1] });
        this.visibility.observe(source);
        this.visibility.observe(ppo);
        this.size = new ResizeObserver(this.schedule);
        this.size.observe(source);
        this.size.observe(ppo);
      }

      syncButton() {
        if (!this.source) return;
        this.syncConfiguredPrice();
        const source = this.source;
        this.button.className = source.className;
        this.button.disabled = source.disabled;
        for (const name of ['aria-label', 'aria-disabled', 'aria-busy', 'aria-haspopup', 'data-ppo-cart-busy']) {
          const value = source.getAttribute(name);
          if (value === null) this.button.removeAttribute(name);
          else this.button.setAttribute(name, value);
        }
        if (this.lastMarkup !== source.innerHTML) {
          this.lastMarkup = source.innerHTML;
          const content = source.cloneNode(true);
          content.querySelectorAll('[id]').forEach(element => element.removeAttribute('id'));
          this.button.replaceChildren(...content.childNodes);
        }
        const style = getComputedStyle(source);
        for (const property of ['font-family', 'font-size', 'font-weight', 'font-style', 'letter-spacing', 'text-transform', 'line-height', 'color', 'background-color', 'border-radius', 'padding-top', 'padding-bottom', '--color-button', '--color-button-text', '--alpha-button-background', '--alpha-button-border', '--buttons-radius', '--buttons-radius-outset', '--buttons-border-width', '--buttons-border-opacity', '--border-offset', '--ppo-cart-busy-color']) {
          this.button.style.setProperty(property, style.getPropertyValue(property));
        }
        this.button.style.minHeight = `${source.getBoundingClientRect().height}px`;
      }

      syncConfiguredPrice() {
        if (!this.hasAttribute('data-configured-price')) return;
        const source = this.source;
        if (source.hasAttribute('data-ppo-cart-busy') || source.getAttribute('aria-busy') === 'true' || source.classList.contains('loading')) return;
        const price = this.configurator.querySelector('.ppo-price');
        const amount = price && !price.querySelector('.ppo-price--pending')
          ? [...price.childNodes].filter(node => node.nodeType === Node.TEXT_NODE).map(node => node.textContent).join('').trim()
          : '';
        let badge = source.querySelector('[data-coverly-configured-price]');
        if (!/\p{N}/u.test(amount) || source.disabled || source.getAttribute('aria-disabled') === 'true') {
          badge?.remove();
          return;
        }
        if (!badge) {
          badge = document.createElement('span');
          badge.setAttribute('data-coverly-configured-price', '');
          const label = source.matches('[id^="ProductSubmitButton-"]') ? source.querySelector(':scope > span') : null;
          (label || source).appendChild(badge);
        }
        const text = ` · ${amount}`;
        if (badge.textContent !== text) badge.textContent = text;
      }

      updateVisibility() {
        if (!this.source?.isConnected || !this.configurator?.isConnected || !this.mobile.matches) {
          this.hidden = true;
          return;
        }
        const rect = this.source.getBoundingClientRect();
        const options = this.configurator.getBoundingClientRect();
        // Wait until the options reach the upper half of the screen so a sliver
        // below the product introduction cannot activate and be covered by the bar.
        const configuring = options.bottom > 0 && options.top < innerHeight / 2 && options.right > 0 && options.left < innerWidth && options.width > 0 && options.height > 0;
        // Show only while configuring, before reaching the main purchase button.
        // Once that button scrolls above the viewport, educational content stays clear.
        const beforePurchase = rect.top >= innerHeight && rect.right > 0 && rect.left < innerWidth;
        const editing = document.activeElement?.matches('input:not([type="button"]):not([type="submit"]):not([type="radio"]):not([type="checkbox"]), textarea, select, [contenteditable="true"]');
        this.hidden = !configuring || !beforePurchase || editing || rect.width === 0 || rect.height === 0 || getComputedStyle(this.source).visibility === 'hidden' || getComputedStyle(this.configurator).visibility === 'hidden';
      }

      disconnectedCallback() {
        this.events?.abort();
        this.events = null;
        this.mounts?.disconnect();
        this.changes?.disconnect();
        this.visibility?.disconnect();
        this.size?.disconnect();
        cancelAnimationFrame(this.frame);
        cancelAnimationFrame(this.visibilityFrame);
        this.frame = 0;
        this.visibilityFrame = 0;
        this.source = null;
        this.configurator = null;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["coverly-shade-ui"] && !Shopify.designMode) return;
  try {
    (() => {
  const motion = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
  class ShadeTabs extends HTMLElement {
    connectedCallback() { this.frame = requestAnimationFrame(() => this.init()); }
    disconnectedCallback() { cancelAnimationFrame(this.frame); this.abort?.abort(); }
    init() {
      this.abort?.abort(); this.abort = new AbortController(); const signal = this.abort.signal;
      this.tabs = [...this.querySelectorAll('[data-tab]')]; this.panels = [...this.querySelectorAll('[data-panel]')];
      if (!this.tabs.length) return;
      this.classList.add('is-enhanced'); this.querySelector('[data-tabs]').setAttribute('role', 'tablist');
      this.tabs.forEach((tab, index) => {
        tab.setAttribute('role', 'tab');
        tab.addEventListener('click', () => this.select(index), {signal});
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % this.tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + this.tabs.length) % this.tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = this.tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); this.select(next); this.tabs[next].focus(); }
        }, {signal});
      });
      this.panels.forEach(panel => { panel.setAttribute('role', 'tabpanel'); panel.tabIndex = 0; });
      this.querySelectorAll('[data-pin]').forEach(pin => pin.addEventListener('click', () => this.select(Number(pin.dataset.pin)), {signal}));
      const pins = this.querySelector('[data-spec-pins]'); if (pins) pins.hidden = false;
      document.addEventListener('shopify:block:select', event => {
        const index = this.panels.findIndex(panel => panel.id.endsWith('-' + event.detail.blockId));
        if (index >= 0) this.select(index);
      }, {signal});
      this.select(0);
    }
    select(index) {
      this.tabs.forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; });
      this.panels.forEach((panel, i) => { panel.hidden = i !== index; });
      this.querySelectorAll('[data-column]').forEach(cell => cell.classList.toggle('is-active', Number(cell.dataset.column) === index));
      this.querySelectorAll('[data-pin]').forEach(pin => pin.setAttribute('aria-pressed', String(Number(pin.dataset.pin) === index)));
    }
  }
  class ShadeHighlights extends HTMLElement {
    connectedCallback() { this.frame = requestAnimationFrame(() => this.init()); }
    disconnectedCallback() { cancelAnimationFrame(this.frame); cancelAnimationFrame(this.scrollFrame); this.abort?.abort(); this.resize?.disconnect(); }
    init() {
      this.abort?.abort(); this.abort = new AbortController(); const signal = this.abort.signal;
      const rail = this.querySelector('[data-rail]'); if (!rail) return;
      const prev = this.querySelector('[data-prev]'), next = this.querySelector('[data-next]');
      const cards = [...rail.children], dots = [...this.querySelectorAll('[data-carousel-dot]')];
      const controls = this.querySelector('[data-carousel-controls]'), pagination = this.querySelector('[data-carousel-pagination]');
      const status = this.querySelector('[data-carousel-status]');
      const rtl = getComputedStyle(rail).direction === 'rtl';
      const maxScroll = () => Math.max(0, rail.scrollWidth - rail.clientWidth);
      const targets = () => {
        if (!cards.length) return [];
        const first = cards[0].getBoundingClientRect(), max = maxScroll();
        return cards.map(card => {
          const bounds = card.getBoundingClientRect();
          return Math.max(0, Math.min(max, rtl ? first.right - bounds.right : bounds.left - first.left));
        });
      };
      const update = () => {
        const x = Math.abs(rail.scrollLeft), max = maxScroll(), points = targets();
        prev.disabled = x < 3; next.disabled = x >= max - 3;
        controls.hidden = max < 3;
        if (pagination) pagination.hidden = cards.length < 2 || max < 3;
        let active = 0;
        if (max > 3 && x >= max - 3) active = cards.length - 1;
        else points.forEach((point, index) => { if (Math.abs(point - x) < Math.abs(points[active] - x)) active = index; });
        dots.forEach((dot, index) => {
          if (index === active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
        const label = dots[active]?.dataset.positionLabel || '';
        if (status && status.textContent !== label) status.textContent = label;
      };
      const goTo = (index, behavior = motion()) => {
        const target = targets()[index];
        if (target !== undefined) rail.scrollTo({left: target * (rtl ? -1 : 1), behavior});
      };
      const move = direction => {
        const x = Math.abs(rail.scrollLeft), points = targets();
        const index = direction > 0 ? points.findIndex(point => point > x + 3) : points.findLastIndex(point => point < x - 3);
        if (index >= 0) goTo(index);
      };
      prev.addEventListener('click', () => move(-1), {signal}); next.addEventListener('click', () => move(1), {signal});
      dots.forEach((dot, index) => dot.addEventListener('click', () => goTo(index), {signal}));
      rail.addEventListener('scroll', () => { cancelAnimationFrame(this.scrollFrame); this.scrollFrame = requestAnimationFrame(update); }, {signal, passive:true});
      rail.addEventListener('keydown', event => {
        if (event.target !== rail) return;
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); move((event.key === 'ArrowRight' ? 1 : -1) * (rtl ? -1 : 1)); }
        if (event.key === 'Home' || event.key === 'End') { event.preventDefault(); goTo(event.key === 'Home' ? 0 : cards.length - 1); }
      }, {signal});
      document.addEventListener('shopify:block:select', event => {
        const index = cards.findIndex(card => card.dataset.blockId === event.detail.blockId);
        if (index >= 0) goTo(index, 'instant');
      }, {signal});
      this.resize?.disconnect(); this.resize = new ResizeObserver(update); this.resize.observe(rail); update();
    }
  }
  class ShadeFeatures extends HTMLElement {
    connectedCallback() { this.frame = requestAnimationFrame(() => this.init()); }
    disconnectedCallback() { cancelAnimationFrame(this.frame); this.abort?.abort(); this.observer?.disconnect(); }
    init() {
      this.abort?.abort(); this.abort = new AbortController(); const signal = this.abort.signal;
      const links = [...this.querySelectorAll('[data-story-link]')], stories = [...this.querySelectorAll('[data-story]')];
      const select = id => links.forEach(link => { if (link.hash === '#' + id) link.setAttribute('aria-current','true'); else link.removeAttribute('aria-current'); });
      links.forEach(link => link.addEventListener('click', event => { const story = stories.find(item => '#' + item.id === link.hash); if (!story) return; event.preventDefault(); story.scrollIntoView({behavior:motion(),block:'start'}); select(story.id); }, {signal}));
      this.observer?.disconnect(); this.observer = new IntersectionObserver(entries => { const visible = entries.filter(entry => entry.isIntersecting); if (visible.length) select(visible[0].target.id); }, {rootMargin:'-15% 0px -50% 0px',threshold:0});
      stories.forEach(story => this.observer.observe(story)); if (stories[0]) select(stories[0].id);
    }
  }
  if (!customElements.get('coverly-shade-compare')) customElements.define('coverly-shade-compare', class extends ShadeTabs {});
  if (!customElements.get('coverly-shade-specs')) customElements.define('coverly-shade-specs', class extends ShadeTabs {});
  if (!customElements.get('coverly-shade-highlights')) customElements.define('coverly-shade-highlights', ShadeHighlights);
  if (!customElements.get('coverly-shade-features')) customElements.define('coverly-shade-features', ShadeFeatures);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["coverly-shipping-badge"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('coverly-shipping-badge')) {
    class CoverlyShippingBadge extends HTMLElement {
      connectedCallback() {
        this.updateEstimate();
        this.timer = window.setInterval(() => this.updateEstimate(), 60000);
        this.abortController = new AbortController();
        document.addEventListener('visibilitychange', () => {
          if (!document.hidden) this.updateEstimate();
        }, { signal: this.abortController.signal });
      }

      disconnectedCallback() {
        window.clearInterval(this.timer);
        this.abortController?.abort();
      }

      updateEstimate(now = new Date()) {
        const days = Number(this.dataset.handlingDays);
        const range = Number(this.dataset.rangeDays);
        if (!Number.isInteger(days) || days < 0 || !Number.isInteger(range) || range < 0) return;
        let today;
        try {
          today = new Intl.DateTimeFormat('en-US', {
            timeZone: this.dataset.timeZone || 'America/New_York',
            year: 'numeric', month: 'numeric', day: 'numeric'
          }).formatToParts(now);
        } catch {
          return;
        }
        const parts = Object.fromEntries(today.map(part => [part.type, part.value]));
        const start = new Date(Date.UTC(Number(parts.year), Number(parts.month) - 1, Number(parts.day) + days, 12));
        const end = new Date(start);
        end.setUTCDate(end.getUTCDate() + range);
        if (!Number.isFinite(start.getTime()) || !Number.isFinite(end.getTime())) return;
        const locale = this.dataset.locale || 'en';
        const isEnglish = /^en(?:-|$)/i.test(locale);
        const showYear = start.getUTCFullYear() !== end.getUTCFullYear();
        const sameMonth = !showYear && start.getUTCMonth() === end.getUTCMonth();
        const formatDate = (date, dayOnly = false) => {
          if (!isEnglish) {
            return new Intl.DateTimeFormat(locale, {
              timeZone: 'UTC', day: 'numeric',
              ...(!dayOnly && { month: 'short' }),
              ...(showYear && { year: 'numeric' })
            }).format(date);
          }
          const day = date.getUTCDate();
          const suffix = day % 100 >= 11 && day % 100 <= 13 ? 'th' : ({ 1: 'st', 2: 'nd', 3: 'rd' }[day % 10] || 'th');
          const month = dayOnly ? '' : new Intl.DateTimeFormat(locale, { month: 'short', timeZone: 'UTC' }).format(date) + ' ';
          return `${month}${day}${suffix}${showYear ? ', ' + date.getUTCFullYear() : ''}`;
        };
        const startDate = formatDate(start);
        const endDate = formatDate(end);
        const dateRange = range === 0 ? startDate : `${startDate} ${this.dataset.separator} ${formatDate(end, sameMonth)}`;
        const values = { date_range: dateRange, start_date: startDate, end_date: endDate };
        const label = this.querySelector('[data-shipping-label]');
        const text = this.dataset.text.replace(/\{(date_range|start_date|end_date)\}/g, (_, token) => values[token]);
        if (label && label.textContent !== text) label.textContent = text;
      }
    }
    customElements.define('coverly-shipping-badge', CoverlyShippingBadge);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["coverly-shutter-measure"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('coverly-shutter-measure')) {
    customElements.define('coverly-shutter-measure', class extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.content = this.querySelector('[data-measure-content]');
        this.main = document.getElementById('MainContent');
        if (!this.dialog || !this.main) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.querySelector('.coverly-measure-dialog__close').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('coverly-measure-open');
          const trigger = this.trigger?.isConnected ? this.trigger : this.main.querySelector('.coverly-measure-button');
          trigger?.focus({ preventScroll: true });
        }, options);
        this.observer = new MutationObserver(records => {
          const selector = '#coverly-configurator, #ppo-configurator, [data-ppo-key="width_inches"]';
          if (records.some(record => [...record.addedNodes, ...record.removedNodes].some(node => node instanceof Element && (node.matches(selector) || node.querySelector(selector))))) this.schedule();
        });
        this.observer.observe(this.main, { childList: true, subtree: true });
        this.refresh();
      }
      schedule() {
        if (this.pending) return;
        this.pending = requestAnimationFrame(() => { this.pending = null; this.refresh(); });
      }
      refresh() {
        this.main.querySelectorAll('#coverly-configurator, #ppo-configurator').forEach(root => {
          if (this.dataset.shutterProduct !== 'true' && !root.querySelector('[data-ppo-key="louver_size"]')) return;
          const width = root.querySelector('[data-ppo-key="width_inches"]');
          const section = width?.closest('.ppo-section');
          const heading = section?.querySelector('.ppo-section__head');
          if (!heading || !width.querySelector('.ppo-tip__src') || heading.querySelector('.coverly-measure-button')) return;
          const button = this.querySelector('[data-measure-trigger]').content.firstElementChild.cloneNode(true);
          heading.classList.add('coverly-measure-heading');
          heading.appendChild(button);
          button.addEventListener('click', event => {
            event.preventDefault();
            event.stopPropagation();
            const source = section.querySelector('[data-ppo-key="width_inches"] .ppo-tip__src');
            if (!source || this.dialog.open) return;
            this.trigger = button;
            this.content.replaceChildren(...[...source.childNodes].map(node => node.cloneNode(true)));
            this.dialog.showModal();
            this.content.scrollTop = 0;
            document.documentElement.classList.add('coverly-measure-open');
          });
        });
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        this.controller?.abort();
        cancelAnimationFrame(this.pending);
        this.dialog?.close();
        document.documentElement.classList.remove('coverly-measure-open');
        this.main?.querySelectorAll('.coverly-measure-button').forEach(button => button.remove());
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["shutter-gallery-preview"] && !Shopify.designMode) return;
  try {
    (function(){
function setup(){document.querySelectorAll('[data-ppo-gallery]').forEach(root=>{
 if(root.dataset.ready)return;root.dataset.ready='true';
 const gallery=root.closest('coverly-gallery'),stage=gallery&&gallery.querySelector('.cvg__stage');
 if(!stage)return;
 const productSection=gallery.closest('[id^="MainProduct-"]')||gallery.closest('.shopify-section');
 const button=root.querySelector('button'),panel=root.querySelector('[data-ppo-panel]'),
       slot=root.querySelector('[data-ppo-mount-slot]'),strip=gallery.querySelector('[data-cvg-strip]');
 // Into the thumbnail rail, second — after the first photograph — and the panel
 // over the stage. Both moves happen before the mount is offered to PPO.
 if(strip)strip.insertBefore(root,strip.children[1]||null);else gallery.append(root);
 stage.append(panel);
 slot.setAttribute('data-ppo-viewer-mount','on-demand');
 let pendingOpen=false;
 // The first thumbnail click or shutter option change loads the 3D page.
 // PPO continues to own the model configuration and iframe protocol.
 const open=()=>{slot.setAttribute('data-ppo-viewer-mount','');panel.hidden=false;stage.classList.add('shutter-preview-active');button.setAttribute('aria-expanded','true');};
 const shut=(moveFocus)=>{pendingOpen=false;panel.hidden=true;stage.classList.remove('shutter-preview-active');button.setAttribute('aria-expanded','false');if(moveFocus)button.focus();};
 const reveal=()=>{const s=slot.getAttribute('data-ppo-viewer');root.hidden=s!=='available'&&s!=='ready';if(pendingOpen&&!root.hidden){pendingOpen=false;open();}};
 const availabilityObserver=new MutationObserver(reveal);
 availabilityObserver.observe(slot,{attributes:true,attributeFilter:['data-ppo-viewer']});
 reveal();
 // These are the storefront option keys used by the shutter viewer connection.
 // Text entry for room names, uploads, warranties and cart actions leave photos alone.
 const modelOptions=new Set(['color','hinge_color','width_inches','width_fractions',
  'height_inches','height_fractions','window_depth_measurement_in_inches',
  'does_your_window_have_molding','does_you_window_have_a_protruding_sill',
  'number_of_panels','panel_configuration','tilt_option','louver_size','frame_type',
  'divider_rail','divider_rail_position','divider_rail_position_30','dr1',
  'divider_rail_location_1','divider_rail_location_2','split_tilt','split_tilt_position']);
 const optionInteraction=e=>{
  const target=e.target instanceof Element?e.target:null;
  if(!target||target.closest('.ppo-tip,[data-ppo-reason]'))return;
  const option=target.closest('[data-ppo-key]');
  if(!option||!option.closest('#coverly-configurator,#ppo-configurator')||!modelOptions.has(option.dataset.ppoKey))return;
  if(e.type==='click'&&!target.closest('[data-ppo-choice]'))return;
  if(target.matches(':disabled')||target.closest('[aria-disabled="true"],.ppo-disabled'))return;
  pendingOpen=true;
  reveal();
 };
 // Capture choice clicks before PPO replaces its option markup during rerender.
 productSection?.addEventListener('click',optionInteraction,true);
 productSection?.addEventListener('change',optionInteraction,true);
 productSection?.addEventListener('input',optionInteraction,true);
 button.addEventListener('click',e=>{e.stopPropagation();panel.hidden?open():shut(true);});
 // Picking another thumbnail means the shopper wants that photograph, not this.
 gallery.addEventListener('click',e=>{if(e.target.closest('[data-cvg-strip-thumb],[data-cvg-prev],[data-cvg-next]'))shut(false);},true);
 panel.addEventListener('keydown',e=>{if(e.key==='Escape')shut(true);});
 panel.addEventListener('click',e=>e.stopPropagation());
 // A gallery that goes away takes its observer with it.
 const gone=new MutationObserver(()=>{if(!gallery.isConnected){
  availabilityObserver.disconnect();
  productSection?.removeEventListener('click',optionInteraction,true);
  productSection?.removeEventListener('change',optionInteraction,true);
  productSection?.removeEventListener('input',optionInteraction,true);
  gone.disconnect();
 }});
 gone.observe(document.body,{childList:true,subtree:true});
});}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',setup);else setup();
document.addEventListener('shopify:section:load',setup);
})();
  } catch(e) { console.error(e); }
})();

})();
